module.exports = __webpack_public_path__ + "static/media/eco-quilla-white-sh.bf84376a.svg";